export const cnpj_mask = (cnpj, isCensored = false) => {
  if (!cnpj) return "";

  cnpj = cnpj.replace(/[.\-\/]/g, "").toUpperCase();

  let firstPartial = cnpj.slice(0, 2);

  let secondPartial = cnpj.slice(2, 5);

  let thirdPartial = cnpj.slice(5, 8);

  let fourthPartial = cnpj.slice(8, cnpj.length - 2);

  let fifthPartial = cnpj.slice(cnpj.length - 2);

  if (isCensored) {
    secondPartial = secondPartial.replaceAll(/[A-Z0-9]/g, "*");

    thirdPartial = thirdPartial.replaceAll(/[A-Z0-9]/g, "*");

    fourthPartial = fourthPartial.replaceAll(/[A-Z0-9]/g, "*");
  }

  return (
    firstPartial +
    "." +
    secondPartial +
    "." +
    thirdPartial +
    "/" +
    fourthPartial +
    "-" +
    fifthPartial
  );
};